import { isString } from 'lodash';
import { UnitedStatesState } from './UnitedStatesState';

const zipCodePrefixMap = {
  '000': UnitedStatesState.none, // Placeholders for areas with no proper zip code or addresses
  '001': UnitedStatesState.none, // Destinations outside U.S.
  '002': UnitedStatesState.none, // Destinations outside U.S.
  '003': UnitedStatesState.none, // Not in use
  '004': UnitedStatesState.none, // Destinations outside U.S.
  '005': UnitedStatesState.NY,
  '006': UnitedStatesState.PR,
  '007': UnitedStatesState.PR,
  '008': UnitedStatesState.VI,
  '009': UnitedStatesState.PR,
  '010': UnitedStatesState.MA,
  '011': UnitedStatesState.MA,
  '012': UnitedStatesState.MA,
  '013': UnitedStatesState.MA,
  '014': UnitedStatesState.MA,
  '015': UnitedStatesState.MA,
  '016': UnitedStatesState.MA,
  '017': UnitedStatesState.MA,
  '018': UnitedStatesState.MA,
  '019': UnitedStatesState.MA,
  '020': UnitedStatesState.MA,
  '021': UnitedStatesState.MA,
  '022': UnitedStatesState.MA,
  '023': UnitedStatesState.MA,
  '024': UnitedStatesState.MA,
  '025': UnitedStatesState.MA,
  '026': UnitedStatesState.MA,
  '027': UnitedStatesState.MA,
  '028': UnitedStatesState.RI,
  '029': UnitedStatesState.RI,
  '030': UnitedStatesState.NH,
  '031': UnitedStatesState.NH,
  '032': UnitedStatesState.NH,
  '033': UnitedStatesState.NH,
  '034': UnitedStatesState.NH,
  '035': UnitedStatesState.NH,
  '036': UnitedStatesState.NH,
  '037': UnitedStatesState.NH,
  '038': UnitedStatesState.NH,
  '039': UnitedStatesState.ME,
  '040': UnitedStatesState.ME,
  '041': UnitedStatesState.ME,
  '042': UnitedStatesState.ME,
  '043': UnitedStatesState.ME,
  '044': UnitedStatesState.ME,
  '045': UnitedStatesState.ME,
  '046': UnitedStatesState.ME,
  '047': UnitedStatesState.ME,
  '048': UnitedStatesState.ME,
  '049': UnitedStatesState.ME,
  '050': UnitedStatesState.VT,
  '051': UnitedStatesState.VT,
  '052': UnitedStatesState.VT,
  '053': UnitedStatesState.VT,
  '054': UnitedStatesState.VT,
  '055': UnitedStatesState.MA,
  '056': UnitedStatesState.VT,
  '057': UnitedStatesState.VT,
  '058': UnitedStatesState.VT,
  '059': UnitedStatesState.VT,
  '060': UnitedStatesState.CT,
  '061': UnitedStatesState.CT,
  '062': UnitedStatesState.CT,
  '063': UnitedStatesState.CT,
  '064': UnitedStatesState.CT,
  '065': UnitedStatesState.CT,
  '066': UnitedStatesState.CT,
  '067': UnitedStatesState.CT,
  '068': UnitedStatesState.CT,
  '069': UnitedStatesState.CT,
  '070': UnitedStatesState.NJ,
  '071': UnitedStatesState.NJ,
  '072': UnitedStatesState.NJ,
  '073': UnitedStatesState.NJ,
  '074': UnitedStatesState.NJ,
  '075': UnitedStatesState.NJ,
  '076': UnitedStatesState.NJ,
  '077': UnitedStatesState.NJ,
  '078': UnitedStatesState.NJ,
  '079': UnitedStatesState.NJ,
  '080': UnitedStatesState.NJ,
  '081': UnitedStatesState.NJ,
  '082': UnitedStatesState.NJ,
  '083': UnitedStatesState.NJ,
  '084': UnitedStatesState.NJ,
  '085': UnitedStatesState.NJ,
  '086': UnitedStatesState.NJ,
  '087': UnitedStatesState.NJ,
  '088': UnitedStatesState.NJ,
  '089': UnitedStatesState.NJ,
  '090': UnitedStatesState.AE,
  '091': UnitedStatesState.AE,
  '092': UnitedStatesState.AE,
  '093': UnitedStatesState.AE,
  '094': UnitedStatesState.AE,
  '095': UnitedStatesState.AE,
  '096': UnitedStatesState.AE,
  '097': UnitedStatesState.AE,
  '098': UnitedStatesState.AE,
  '099': UnitedStatesState.AE,
  '100': UnitedStatesState.NY,
  '101': UnitedStatesState.NY,
  '102': UnitedStatesState.NY,
  '103': UnitedStatesState.NY,
  '104': UnitedStatesState.NY,
  '105': UnitedStatesState.NY,
  '106': UnitedStatesState.NY,
  '107': UnitedStatesState.NY,
  '108': UnitedStatesState.NY,
  '109': UnitedStatesState.NY,
  '110': UnitedStatesState.NY,
  '111': UnitedStatesState.NY,
  '112': UnitedStatesState.NY,
  '113': UnitedStatesState.NY,
  '114': UnitedStatesState.NY,
  '115': UnitedStatesState.NY,
  '116': UnitedStatesState.NY,
  '117': UnitedStatesState.NY,
  '118': UnitedStatesState.NY,
  '119': UnitedStatesState.NY,
  '120': UnitedStatesState.NY,
  '121': UnitedStatesState.NY,
  '122': UnitedStatesState.NY,
  '123': UnitedStatesState.NY,
  '124': UnitedStatesState.NY,
  '125': UnitedStatesState.NY,
  '126': UnitedStatesState.NY,
  '127': UnitedStatesState.NY,
  '128': UnitedStatesState.NY,
  '129': UnitedStatesState.NY,
  '130': UnitedStatesState.NY,
  '131': UnitedStatesState.NY,
  '132': UnitedStatesState.NY,
  '133': UnitedStatesState.NY,
  '134': UnitedStatesState.NY,
  '135': UnitedStatesState.NY,
  '136': UnitedStatesState.NY,
  '137': UnitedStatesState.NY,
  '138': UnitedStatesState.NY,
  '139': UnitedStatesState.NY,
  '140': UnitedStatesState.NY,
  '141': UnitedStatesState.NY,
  '142': UnitedStatesState.NY,
  '143': UnitedStatesState.NY,
  '144': UnitedStatesState.NY,
  '145': UnitedStatesState.NY,
  '146': UnitedStatesState.NY,
  '147': UnitedStatesState.NY,
  '148': UnitedStatesState.NY,
  '149': UnitedStatesState.NY,
  '150': UnitedStatesState.PA,
  '151': UnitedStatesState.PA,
  '152': UnitedStatesState.PA,
  '153': UnitedStatesState.PA,
  '154': UnitedStatesState.PA,
  '155': UnitedStatesState.PA,
  '156': UnitedStatesState.PA,
  '157': UnitedStatesState.PA,
  '158': UnitedStatesState.PA,
  '159': UnitedStatesState.PA,
  '160': UnitedStatesState.PA,
  '161': UnitedStatesState.PA,
  '162': UnitedStatesState.PA,
  '163': UnitedStatesState.PA,
  '164': UnitedStatesState.PA,
  '165': UnitedStatesState.PA,
  '166': UnitedStatesState.PA,
  '167': UnitedStatesState.PA,
  '168': UnitedStatesState.PA,
  '169': UnitedStatesState.PA,
  '170': UnitedStatesState.PA,
  '171': UnitedStatesState.PA,
  '172': UnitedStatesState.PA,
  '173': UnitedStatesState.PA,
  '174': UnitedStatesState.PA,
  '175': UnitedStatesState.PA,
  '176': UnitedStatesState.PA,
  '177': UnitedStatesState.PA,
  '178': UnitedStatesState.PA,
  '179': UnitedStatesState.PA,
  '180': UnitedStatesState.PA,
  '181': UnitedStatesState.PA,
  '182': UnitedStatesState.PA,
  '183': UnitedStatesState.PA,
  '184': UnitedStatesState.PA,
  '185': UnitedStatesState.PA,
  '186': UnitedStatesState.PA,
  '187': UnitedStatesState.PA,
  '188': UnitedStatesState.PA,
  '189': UnitedStatesState.PA,
  '190': UnitedStatesState.PA,
  '191': UnitedStatesState.PA,
  '192': UnitedStatesState.PA,
  '193': UnitedStatesState.PA,
  '194': UnitedStatesState.PA,
  '195': UnitedStatesState.PA,
  '196': UnitedStatesState.PA,
  '197': UnitedStatesState.DE,
  '198': UnitedStatesState.DE,
  '199': UnitedStatesState.DE,
  '200': UnitedStatesState.DC,
  '201': UnitedStatesState.VA,
  '202': UnitedStatesState.DC,
  '203': UnitedStatesState.DC,
  '204': UnitedStatesState.DC,
  '205': UnitedStatesState.DC,
  '206': UnitedStatesState.MD,
  '207': UnitedStatesState.MD,
  '208': UnitedStatesState.MD,
  '209': UnitedStatesState.MD,
  '210': UnitedStatesState.MD,
  '211': UnitedStatesState.MD,
  '212': UnitedStatesState.MD,
  '213': UnitedStatesState.none, // Not in use
  '214': UnitedStatesState.MD,
  '215': UnitedStatesState.MD,
  '216': UnitedStatesState.MD,
  '217': UnitedStatesState.MD,
  '218': UnitedStatesState.MD,
  '219': UnitedStatesState.MD,
  '220': UnitedStatesState.VA,
  '221': UnitedStatesState.VA,
  '222': UnitedStatesState.VA,
  '223': UnitedStatesState.VA,
  '224': UnitedStatesState.VA,
  '225': UnitedStatesState.VA,
  '226': UnitedStatesState.VA,
  '227': UnitedStatesState.VA,
  '228': UnitedStatesState.VA,
  '229': UnitedStatesState.VA,
  '230': UnitedStatesState.VA,
  '231': UnitedStatesState.VA,
  '232': UnitedStatesState.VA,
  '233': UnitedStatesState.VA,
  '234': UnitedStatesState.VA,
  '235': UnitedStatesState.VA,
  '236': UnitedStatesState.VA,
  '237': UnitedStatesState.VA,
  '238': UnitedStatesState.VA,
  '239': UnitedStatesState.VA,
  '240': UnitedStatesState.VA,
  '241': UnitedStatesState.VA,
  '242': UnitedStatesState.VA,
  '243': UnitedStatesState.VA,
  '244': UnitedStatesState.VA,
  '245': UnitedStatesState.VA,
  '246': UnitedStatesState.VA,
  '247': UnitedStatesState.WV,
  '248': UnitedStatesState.WV,
  '249': UnitedStatesState.WV,
  '250': UnitedStatesState.WV,
  '251': UnitedStatesState.WV,
  '252': UnitedStatesState.WV,
  '253': UnitedStatesState.WV,
  '254': UnitedStatesState.WV,
  '255': UnitedStatesState.WV,
  '256': UnitedStatesState.WV,
  '257': UnitedStatesState.WV,
  '258': UnitedStatesState.WV,
  '259': UnitedStatesState.WV,
  '260': UnitedStatesState.WV,
  '261': UnitedStatesState.WV,
  '262': UnitedStatesState.WV,
  '263': UnitedStatesState.WV,
  '264': UnitedStatesState.WV,
  '265': UnitedStatesState.WV,
  '266': UnitedStatesState.WV,
  '267': UnitedStatesState.WV,
  '268': UnitedStatesState.WV,
  '269': UnitedStatesState.none, // Discontinued
  '270': UnitedStatesState.NC,
  '271': UnitedStatesState.NC,
  '272': UnitedStatesState.NC,
  '273': UnitedStatesState.NC,
  '274': UnitedStatesState.NC,
  '275': UnitedStatesState.NC,
  '276': UnitedStatesState.NC,
  '277': UnitedStatesState.NC,
  '278': UnitedStatesState.NC,
  '279': UnitedStatesState.NC,
  '280': UnitedStatesState.NC,
  '281': UnitedStatesState.NC,
  '282': UnitedStatesState.NC,
  '283': UnitedStatesState.NC,
  '284': UnitedStatesState.NC,
  '285': UnitedStatesState.NC,
  '286': UnitedStatesState.NC,
  '287': UnitedStatesState.NC,
  '288': UnitedStatesState.NC,
  '289': UnitedStatesState.NC,
  '290': UnitedStatesState.SC,
  '291': UnitedStatesState.SC,
  '292': UnitedStatesState.SC,
  '293': UnitedStatesState.SC,
  '294': UnitedStatesState.SC,
  '295': UnitedStatesState.SC,
  '296': UnitedStatesState.SC,
  '297': UnitedStatesState.SC,
  '298': UnitedStatesState.SC,
  '299': UnitedStatesState.SC,
  '300': UnitedStatesState.GA,
  '301': UnitedStatesState.GA,
  '302': UnitedStatesState.GA,
  '303': UnitedStatesState.GA,
  '304': UnitedStatesState.GA,
  '305': UnitedStatesState.GA,
  '306': UnitedStatesState.GA,
  '307': UnitedStatesState.GA,
  '308': UnitedStatesState.GA,
  '309': UnitedStatesState.GA,
  '310': UnitedStatesState.GA,
  '311': UnitedStatesState.GA,
  '312': UnitedStatesState.GA,
  '313': UnitedStatesState.GA,
  '314': UnitedStatesState.GA,
  '315': UnitedStatesState.GA,
  '316': UnitedStatesState.GA,
  '317': UnitedStatesState.GA,
  '318': UnitedStatesState.GA,
  '319': UnitedStatesState.GA,
  '320': UnitedStatesState.FL,
  '321': UnitedStatesState.FL,
  '322': UnitedStatesState.FL,
  '323': UnitedStatesState.FL,
  '324': UnitedStatesState.FL,
  '325': UnitedStatesState.FL,
  '326': UnitedStatesState.FL,
  '327': UnitedStatesState.FL,
  '328': UnitedStatesState.FL,
  '329': UnitedStatesState.FL,
  '330': UnitedStatesState.FL,
  '331': UnitedStatesState.FL,
  '332': UnitedStatesState.FL,
  '333': UnitedStatesState.FL,
  '334': UnitedStatesState.FL,
  '335': UnitedStatesState.FL,
  '336': UnitedStatesState.FL,
  '337': UnitedStatesState.FL,
  '338': UnitedStatesState.FL,
  '339': UnitedStatesState.FL,
  '340': UnitedStatesState.AA,
  '341': UnitedStatesState.FL,
  '342': UnitedStatesState.FL,
  '343': UnitedStatesState.none,
  '344': UnitedStatesState.FL,
  '345': UnitedStatesState.none,
  '346': UnitedStatesState.FL,
  '347': UnitedStatesState.FL,
  '348': UnitedStatesState.none,
  '349': UnitedStatesState.FL,
  '350': UnitedStatesState.AL,
  '351': UnitedStatesState.AL,
  '352': UnitedStatesState.AL,
  '353': UnitedStatesState.none,
  '354': UnitedStatesState.AL,
  '355': UnitedStatesState.AL,
  '356': UnitedStatesState.AL,
  '357': UnitedStatesState.AL,
  '358': UnitedStatesState.AL,
  '359': UnitedStatesState.AL,
  '360': UnitedStatesState.AL,
  '361': UnitedStatesState.AL,
  '362': UnitedStatesState.AL,
  '363': UnitedStatesState.AL,
  '364': UnitedStatesState.AL,
  '365': UnitedStatesState.AL,
  '366': UnitedStatesState.AL,
  '367': UnitedStatesState.AL,
  '368': UnitedStatesState.AL,
  '369': UnitedStatesState.AL,
  '370': UnitedStatesState.TN,
  '371': UnitedStatesState.TN,
  '372': UnitedStatesState.TN,
  '373': UnitedStatesState.TN,
  '374': UnitedStatesState.TN,
  '375': UnitedStatesState.TN,
  '376': UnitedStatesState.TN,
  '377': UnitedStatesState.TN,
  '378': UnitedStatesState.TN,
  '379': UnitedStatesState.TN,
  '380': UnitedStatesState.TN,
  '381': UnitedStatesState.TN,
  '382': UnitedStatesState.TN,
  '383': UnitedStatesState.TN,
  '384': UnitedStatesState.TN,
  '385': UnitedStatesState.TN,
  '386': UnitedStatesState.MS,
  '387': UnitedStatesState.MS,
  '388': UnitedStatesState.MS,
  '389': UnitedStatesState.MS,
  '390': UnitedStatesState.MS,
  '391': UnitedStatesState.MS,
  '392': UnitedStatesState.MS,
  '393': UnitedStatesState.MS,
  '394': UnitedStatesState.MS,
  '395': UnitedStatesState.MS,
  '396': UnitedStatesState.MS,
  '397': UnitedStatesState.MS,
  '398': UnitedStatesState.GA,
  '399': UnitedStatesState.GA,
  '400': UnitedStatesState.KY,
  '401': UnitedStatesState.KY,
  '402': UnitedStatesState.KY,
  '403': UnitedStatesState.KY,
  '404': UnitedStatesState.KY,
  '405': UnitedStatesState.KY,
  '406': UnitedStatesState.KY,
  '407': UnitedStatesState.KY,
  '408': UnitedStatesState.KY,
  '409': UnitedStatesState.KY,
  '410': UnitedStatesState.KY,
  '411': UnitedStatesState.KY,
  '412': UnitedStatesState.KY,
  '413': UnitedStatesState.KY,
  '414': UnitedStatesState.KY,
  '415': UnitedStatesState.KY,
  '416': UnitedStatesState.KY,
  '417': UnitedStatesState.KY,
  '418': UnitedStatesState.KY,
  '419': UnitedStatesState.none,
  '420': UnitedStatesState.KY,
  '421': UnitedStatesState.KY,
  '422': UnitedStatesState.KY,
  '423': UnitedStatesState.KY,
  '424': UnitedStatesState.KY,
  '425': UnitedStatesState.KY,
  '426': UnitedStatesState.KY,
  '427': UnitedStatesState.KY,
  '428': UnitedStatesState.none,
  '429': UnitedStatesState.none,
  '430': UnitedStatesState.OH,
  '431': UnitedStatesState.OH,
  '432': UnitedStatesState.OH,
  '433': UnitedStatesState.OH,
  '434': UnitedStatesState.OH,
  '435': UnitedStatesState.OH,
  '436': UnitedStatesState.OH,
  '437': UnitedStatesState.OH,
  '438': UnitedStatesState.OH,
  '439': UnitedStatesState.OH,
  '440': UnitedStatesState.OH,
  '441': UnitedStatesState.OH,
  '442': UnitedStatesState.OH,
  '443': UnitedStatesState.OH,
  '444': UnitedStatesState.OH,
  '445': UnitedStatesState.OH,
  '446': UnitedStatesState.OH,
  '447': UnitedStatesState.OH,
  '448': UnitedStatesState.OH,
  '449': UnitedStatesState.OH,
  '450': UnitedStatesState.OH,
  '451': UnitedStatesState.OH,
  '452': UnitedStatesState.OH,
  '453': UnitedStatesState.OH,
  '454': UnitedStatesState.OH,
  '455': UnitedStatesState.OH,
  '456': UnitedStatesState.OH,
  '457': UnitedStatesState.OH,
  '458': UnitedStatesState.OH,
  '459': UnitedStatesState.OH,
  '460': UnitedStatesState.IN,
  '461': UnitedStatesState.IN,
  '462': UnitedStatesState.IN,
  '463': UnitedStatesState.IN,
  '464': UnitedStatesState.IN,
  '465': UnitedStatesState.IN,
  '466': UnitedStatesState.IN,
  '467': UnitedStatesState.IN,
  '468': UnitedStatesState.IN,
  '469': UnitedStatesState.IN,
  '470': UnitedStatesState.IN,
  '471': UnitedStatesState.IN,
  '472': UnitedStatesState.IN,
  '473': UnitedStatesState.IN,
  '474': UnitedStatesState.IN,
  '475': UnitedStatesState.IN,
  '476': UnitedStatesState.IN,
  '477': UnitedStatesState.IN,
  '478': UnitedStatesState.IN,
  '479': UnitedStatesState.IN,
  '480': UnitedStatesState.MI,
  '481': UnitedStatesState.MI,
  '482': UnitedStatesState.MI,
  '483': UnitedStatesState.MI,
  '484': UnitedStatesState.MI,
  '485': UnitedStatesState.MI,
  '486': UnitedStatesState.MI,
  '487': UnitedStatesState.MI,
  '488': UnitedStatesState.MI,
  '489': UnitedStatesState.MI,
  '490': UnitedStatesState.MI,
  '491': UnitedStatesState.MI,
  '492': UnitedStatesState.MI,
  '493': UnitedStatesState.MI,
  '494': UnitedStatesState.MI,
  '495': UnitedStatesState.MI,
  '496': UnitedStatesState.MI,
  '497': UnitedStatesState.MI,
  '498': UnitedStatesState.MI,
  '499': UnitedStatesState.MI,
  '500': UnitedStatesState.IA,
  '501': UnitedStatesState.IA,
  '502': UnitedStatesState.IA,
  '503': UnitedStatesState.IA,
  '504': UnitedStatesState.IA,
  '505': UnitedStatesState.IA,
  '506': UnitedStatesState.IA,
  '507': UnitedStatesState.IA,
  '508': UnitedStatesState.IA,
  '509': UnitedStatesState.IA,
  '510': UnitedStatesState.IA,
  '511': UnitedStatesState.IA,
  '512': UnitedStatesState.IA,
  '513': UnitedStatesState.IA,
  '514': UnitedStatesState.IA,
  '515': UnitedStatesState.IA,
  '516': UnitedStatesState.IA,
  '517': UnitedStatesState.none,
  '518': UnitedStatesState.none,
  '519': UnitedStatesState.none,
  '520': UnitedStatesState.IA,
  '521': UnitedStatesState.IA,
  '522': UnitedStatesState.IA,
  '523': UnitedStatesState.IA,
  '524': UnitedStatesState.IA,
  '525': UnitedStatesState.IA,
  '526': UnitedStatesState.IA,
  '527': UnitedStatesState.IA,
  '528': UnitedStatesState.IA,
  '529': UnitedStatesState.none,
  '530': UnitedStatesState.WI,
  '531': UnitedStatesState.WI,
  '532': UnitedStatesState.WI,
  '533': UnitedStatesState.none,
  '534': UnitedStatesState.WI,
  '535': UnitedStatesState.WI,
  '536': UnitedStatesState.none,
  '537': UnitedStatesState.WI,
  '538': UnitedStatesState.WI,
  '539': UnitedStatesState.WI,
  '540': UnitedStatesState.WI,
  '541': UnitedStatesState.WI,
  '542': UnitedStatesState.WI,
  '543': UnitedStatesState.WI,
  '544': UnitedStatesState.WI,
  '545': UnitedStatesState.WI,
  '546': UnitedStatesState.WI,
  '547': UnitedStatesState.WI,
  '548': UnitedStatesState.WI,
  '549': UnitedStatesState.WI,
  '550': UnitedStatesState.MN,
  '551': UnitedStatesState.MN,
  '552': UnitedStatesState.none,
  '553': UnitedStatesState.MN,
  '554': UnitedStatesState.MN,
  '555': UnitedStatesState.MN,
  '556': UnitedStatesState.MN,
  '557': UnitedStatesState.MN,
  '558': UnitedStatesState.MN,
  '559': UnitedStatesState.MN,
  '560': UnitedStatesState.MN,
  '561': UnitedStatesState.MN,
  '562': UnitedStatesState.MN,
  '563': UnitedStatesState.MN,
  '564': UnitedStatesState.MN,
  '565': UnitedStatesState.MN,
  '566': UnitedStatesState.MN,
  '567': UnitedStatesState.MN,
  '568': UnitedStatesState.none,
  '569': UnitedStatesState.DC,
  '570': UnitedStatesState.SD,
  '571': UnitedStatesState.SD,
  '572': UnitedStatesState.SD,
  '573': UnitedStatesState.SD,
  '574': UnitedStatesState.SD,
  '575': UnitedStatesState.SD,
  '576': UnitedStatesState.SD,
  '577': UnitedStatesState.SD,
  '578': UnitedStatesState.none,
  '579': UnitedStatesState.none,
  '580': UnitedStatesState.ND,
  '581': UnitedStatesState.ND,
  '582': UnitedStatesState.ND,
  '583': UnitedStatesState.ND,
  '584': UnitedStatesState.ND,
  '585': UnitedStatesState.ND,
  '586': UnitedStatesState.ND,
  '587': UnitedStatesState.ND,
  '588': UnitedStatesState.ND,
  '589': UnitedStatesState.none,
  '590': UnitedStatesState.MT,
  '591': UnitedStatesState.MT,
  '592': UnitedStatesState.MT,
  '593': UnitedStatesState.MT,
  '594': UnitedStatesState.MT,
  '595': UnitedStatesState.MT,
  '596': UnitedStatesState.MT,
  '597': UnitedStatesState.MT,
  '598': UnitedStatesState.MT,
  '599': UnitedStatesState.MT,
  '600': UnitedStatesState.IL,
  '601': UnitedStatesState.IL,
  '602': UnitedStatesState.IL,
  '603': UnitedStatesState.IL,
  '604': UnitedStatesState.IL,
  '605': UnitedStatesState.IL,
  '606': UnitedStatesState.IL,
  '607': UnitedStatesState.IL,
  '608': UnitedStatesState.IL,
  '609': UnitedStatesState.IL,
  '610': UnitedStatesState.IL,
  '611': UnitedStatesState.IL,
  '612': UnitedStatesState.IL,
  '613': UnitedStatesState.IL,
  '614': UnitedStatesState.IL,
  '615': UnitedStatesState.IL,
  '616': UnitedStatesState.IL,
  '617': UnitedStatesState.IL,
  '618': UnitedStatesState.IL,
  '619': UnitedStatesState.IL,
  '620': UnitedStatesState.IL,
  '621': UnitedStatesState.none,
  '622': UnitedStatesState.IL,
  '623': UnitedStatesState.IL,
  '624': UnitedStatesState.IL,
  '625': UnitedStatesState.IL,
  '626': UnitedStatesState.IL,
  '627': UnitedStatesState.IL,
  '628': UnitedStatesState.IL,
  '629': UnitedStatesState.IL,
  '630': UnitedStatesState.MO,
  '631': UnitedStatesState.MO,
  '632': UnitedStatesState.none,
  '633': UnitedStatesState.MO,
  '634': UnitedStatesState.MO,
  '635': UnitedStatesState.MO,
  '636': UnitedStatesState.MO,
  '637': UnitedStatesState.MO,
  '638': UnitedStatesState.MO,
  '639': UnitedStatesState.MO,
  '640': UnitedStatesState.MO,
  '641': UnitedStatesState.MO,
  '642': UnitedStatesState.none,
  '643': UnitedStatesState.none,
  '644': UnitedStatesState.MO,
  '645': UnitedStatesState.MO,
  '646': UnitedStatesState.MO,
  '647': UnitedStatesState.MO,
  '648': UnitedStatesState.MO,
  '649': UnitedStatesState.MO,
  '650': UnitedStatesState.MO,
  '651': UnitedStatesState.MO,
  '652': UnitedStatesState.MO,
  '653': UnitedStatesState.MO,
  '654': UnitedStatesState.MO,
  '655': UnitedStatesState.MO,
  '656': UnitedStatesState.MO,
  '657': UnitedStatesState.MO,
  '658': UnitedStatesState.MO,
  '659': UnitedStatesState.none,
  '660': UnitedStatesState.KS,
  '661': UnitedStatesState.KS,
  '662': UnitedStatesState.KS,
  '663': UnitedStatesState.none,
  '664': UnitedStatesState.KS,
  '665': UnitedStatesState.KS,
  '666': UnitedStatesState.KS,
  '667': UnitedStatesState.KS,
  '668': UnitedStatesState.KS,
  '669': UnitedStatesState.KS,
  '670': UnitedStatesState.KS,
  '671': UnitedStatesState.KS,
  '672': UnitedStatesState.KS,
  '673': UnitedStatesState.KS,
  '674': UnitedStatesState.KS,
  '675': UnitedStatesState.KS,
  '676': UnitedStatesState.KS,
  '677': UnitedStatesState.KS,
  '678': UnitedStatesState.KS,
  '679': UnitedStatesState.KS,
  '680': UnitedStatesState.NE,
  '681': UnitedStatesState.NE,
  '682': UnitedStatesState.none,
  '683': UnitedStatesState.NE,
  '684': UnitedStatesState.NE,
  '685': UnitedStatesState.NE,
  '686': UnitedStatesState.NE,
  '687': UnitedStatesState.NE,
  '688': UnitedStatesState.NE,
  '689': UnitedStatesState.NE,
  '690': UnitedStatesState.NE,
  '691': UnitedStatesState.NE,
  '692': UnitedStatesState.NE,
  '693': UnitedStatesState.NE,
  '694': UnitedStatesState.none,
  '695': UnitedStatesState.none,
  '696': UnitedStatesState.none,
  '697': UnitedStatesState.none,
  '698': UnitedStatesState.none,
  '699': UnitedStatesState.none,
  '700': UnitedStatesState.LA,
  '701': UnitedStatesState.LA,
  '702': UnitedStatesState.none,
  '703': UnitedStatesState.LA,
  '704': UnitedStatesState.LA,
  '705': UnitedStatesState.LA,
  '706': UnitedStatesState.LA,
  '707': UnitedStatesState.LA,
  '708': UnitedStatesState.LA,
  '709': UnitedStatesState.none,
  '710': UnitedStatesState.LA,
  '711': UnitedStatesState.LA,
  '712': UnitedStatesState.LA,
  '713': UnitedStatesState.LA,
  '714': UnitedStatesState.LA,
  '715': UnitedStatesState.none,
  '716': UnitedStatesState.AR,
  '717': UnitedStatesState.AR,
  '718': UnitedStatesState.AR,
  '719': UnitedStatesState.AR,
  '720': UnitedStatesState.AR,
  '721': UnitedStatesState.AR,
  '722': UnitedStatesState.AR,
  '723': UnitedStatesState.AR,
  '724': UnitedStatesState.AR,
  '725': UnitedStatesState.AR,
  '726': UnitedStatesState.AR,
  '727': UnitedStatesState.AR,
  '728': UnitedStatesState.AR,
  '729': UnitedStatesState.AR,
  '730': UnitedStatesState.OK,
  '731': UnitedStatesState.OK,
  '732': UnitedStatesState.none,
  '733': UnitedStatesState.TX,
  '734': UnitedStatesState.OK,
  '735': UnitedStatesState.OK,
  '736': UnitedStatesState.OK,
  '737': UnitedStatesState.OK,
  '738': UnitedStatesState.OK,
  '739': UnitedStatesState.OK,
  '740': UnitedStatesState.OK,
  '741': UnitedStatesState.OK,
  '742': UnitedStatesState.none,
  '743': UnitedStatesState.OK,
  '744': UnitedStatesState.OK,
  '745': UnitedStatesState.OK,
  '746': UnitedStatesState.OK,
  '747': UnitedStatesState.OK,
  '748': UnitedStatesState.OK,
  '749': UnitedStatesState.OK,
  '750': UnitedStatesState.TX,
  '751': UnitedStatesState.TX,
  '752': UnitedStatesState.TX,
  '753': UnitedStatesState.TX,
  '754': UnitedStatesState.TX,
  '755': UnitedStatesState.TX,
  '756': UnitedStatesState.TX,
  '757': UnitedStatesState.TX,
  '758': UnitedStatesState.TX,
  '759': UnitedStatesState.TX,
  '760': UnitedStatesState.TX,
  '761': UnitedStatesState.TX,
  '762': UnitedStatesState.TX,
  '763': UnitedStatesState.TX,
  '764': UnitedStatesState.TX,
  '765': UnitedStatesState.TX,
  '766': UnitedStatesState.TX,
  '767': UnitedStatesState.TX,
  '768': UnitedStatesState.TX,
  '769': UnitedStatesState.TX,
  '770': UnitedStatesState.TX,
  '771': UnitedStatesState.none,
  '772': UnitedStatesState.TX,
  '773': UnitedStatesState.TX,
  '774': UnitedStatesState.TX,
  '775': UnitedStatesState.TX,
  '776': UnitedStatesState.TX,
  '777': UnitedStatesState.TX,
  '778': UnitedStatesState.TX,
  '779': UnitedStatesState.TX,
  '780': UnitedStatesState.TX,
  '781': UnitedStatesState.TX,
  '782': UnitedStatesState.TX,
  '783': UnitedStatesState.TX,
  '784': UnitedStatesState.TX,
  '785': UnitedStatesState.TX,
  '786': UnitedStatesState.TX,
  '787': UnitedStatesState.TX,
  '788': UnitedStatesState.TX,
  '789': UnitedStatesState.TX,
  '790': UnitedStatesState.TX,
  '791': UnitedStatesState.TX,
  '792': UnitedStatesState.TX,
  '793': UnitedStatesState.TX,
  '794': UnitedStatesState.TX,
  '795': UnitedStatesState.TX,
  '796': UnitedStatesState.TX,
  '797': UnitedStatesState.TX,
  '798': UnitedStatesState.TX,
  '799': UnitedStatesState.TX,
  '800': UnitedStatesState.CO,
  '801': UnitedStatesState.CO,
  '802': UnitedStatesState.CO,
  '803': UnitedStatesState.CO,
  '804': UnitedStatesState.CO,
  '805': UnitedStatesState.CO,
  '806': UnitedStatesState.CO,
  '807': UnitedStatesState.CO,
  '808': UnitedStatesState.CO,
  '809': UnitedStatesState.CO,
  '810': UnitedStatesState.CO,
  '811': UnitedStatesState.CO,
  '812': UnitedStatesState.CO,
  '813': UnitedStatesState.CO,
  '814': UnitedStatesState.CO,
  '815': UnitedStatesState.CO,
  '816': UnitedStatesState.CO,
  '817': UnitedStatesState.none,
  '818': UnitedStatesState.none,
  '819': UnitedStatesState.none,
  '820': UnitedStatesState.WY,
  '821': UnitedStatesState.WY,
  '822': UnitedStatesState.WY,
  '823': UnitedStatesState.WY,
  '824': UnitedStatesState.WY,
  '825': UnitedStatesState.WY,
  '826': UnitedStatesState.WY,
  '827': UnitedStatesState.WY,
  '828': UnitedStatesState.WY,
  '829': UnitedStatesState.WY,
  '830': UnitedStatesState.WY,
  '831': UnitedStatesState.WY,
  '832': UnitedStatesState.ID,
  '833': UnitedStatesState.ID,
  '834': UnitedStatesState.ID,
  '835': UnitedStatesState.ID,
  '836': UnitedStatesState.ID,
  '837': UnitedStatesState.ID,
  '838': UnitedStatesState.ID,
  '839': UnitedStatesState.none,
  '840': UnitedStatesState.UT,
  '841': UnitedStatesState.UT,
  '842': UnitedStatesState.UT,
  '843': UnitedStatesState.UT,
  '844': UnitedStatesState.UT,
  '845': UnitedStatesState.UT,
  '846': UnitedStatesState.UT,
  '847': UnitedStatesState.UT,
  '848': UnitedStatesState.none,
  '849': UnitedStatesState.none,
  '850': UnitedStatesState.AZ,
  '851': UnitedStatesState.AZ,
  '852': UnitedStatesState.AZ,
  '853': UnitedStatesState.AZ,
  '854': UnitedStatesState.none,
  '855': UnitedStatesState.AZ,
  '856': UnitedStatesState.AZ,
  '857': UnitedStatesState.AZ,
  '858': UnitedStatesState.none,
  '859': UnitedStatesState.AZ,
  '860': UnitedStatesState.AZ,
  '861': UnitedStatesState.none,
  '862': UnitedStatesState.none,
  '863': UnitedStatesState.AZ,
  '864': UnitedStatesState.AZ,
  '865': UnitedStatesState.AZ,
  '866': UnitedStatesState.none,
  '867': UnitedStatesState.none,
  '868': UnitedStatesState.none,
  '869': UnitedStatesState.none,
  '870': UnitedStatesState.NM,
  '871': UnitedStatesState.NM,
  '872': UnitedStatesState.none,
  '873': UnitedStatesState.NM,
  '874': UnitedStatesState.NM,
  '875': UnitedStatesState.NM,
  '876': UnitedStatesState.none,
  '877': UnitedStatesState.NM,
  '878': UnitedStatesState.NM,
  '879': UnitedStatesState.NM,
  '880': UnitedStatesState.NM,
  '881': UnitedStatesState.NM,
  '882': UnitedStatesState.NM,
  '883': UnitedStatesState.NM,
  '884': UnitedStatesState.NM,
  '885': UnitedStatesState.TX,
  '886': UnitedStatesState.none,
  '887': UnitedStatesState.none,
  '888': UnitedStatesState.none,
  '889': UnitedStatesState.NV,
  '890': UnitedStatesState.NV,
  '891': UnitedStatesState.NV,
  '892': UnitedStatesState.none,
  '893': UnitedStatesState.NV,
  '894': UnitedStatesState.NV,
  '895': UnitedStatesState.NV,
  '896': UnitedStatesState.none,
  '897': UnitedStatesState.NV,
  '898': UnitedStatesState.NV,
  '899': UnitedStatesState.none,
  '900': UnitedStatesState.CA,
  '901': UnitedStatesState.CA,
  '902': UnitedStatesState.CA,
  '903': UnitedStatesState.CA,
  '904': UnitedStatesState.CA,
  '905': UnitedStatesState.CA,
  '906': UnitedStatesState.CA,
  '907': UnitedStatesState.CA,
  '908': UnitedStatesState.CA,
  '909': UnitedStatesState.none,
  '910': UnitedStatesState.CA,
  '911': UnitedStatesState.CA,
  '912': UnitedStatesState.CA,
  '913': UnitedStatesState.CA,
  '914': UnitedStatesState.CA,
  '915': UnitedStatesState.CA,
  '916': UnitedStatesState.CA,
  '917': UnitedStatesState.CA,
  '918': UnitedStatesState.CA,
  '919': UnitedStatesState.CA,
  '920': UnitedStatesState.CA,
  '921': UnitedStatesState.CA,
  '922': UnitedStatesState.CA,
  '923': UnitedStatesState.CA,
  '924': UnitedStatesState.CA,
  '925': UnitedStatesState.CA,
  '926': UnitedStatesState.CA,
  '927': UnitedStatesState.CA,
  '928': UnitedStatesState.CA,
  '929': UnitedStatesState.none,
  '930': UnitedStatesState.CA,
  '931': UnitedStatesState.CA,
  '932': UnitedStatesState.CA,
  '933': UnitedStatesState.CA,
  '934': UnitedStatesState.CA,
  '935': UnitedStatesState.CA,
  '936': UnitedStatesState.CA,
  '937': UnitedStatesState.CA,
  '938': UnitedStatesState.CA,
  '939': UnitedStatesState.CA,
  '940': UnitedStatesState.CA,
  '941': UnitedStatesState.CA,
  '942': UnitedStatesState.CA,
  '943': UnitedStatesState.CA,
  '944': UnitedStatesState.CA,
  '945': UnitedStatesState.CA,
  '946': UnitedStatesState.CA,
  '947': UnitedStatesState.CA,
  '948': UnitedStatesState.CA,
  '949': UnitedStatesState.CA,
  '950': UnitedStatesState.CA,
  '951': UnitedStatesState.CA,
  '952': UnitedStatesState.CA,
  '953': UnitedStatesState.CA,
  '954': UnitedStatesState.CA,
  '955': UnitedStatesState.CA,
  '956': UnitedStatesState.CA,
  '957': UnitedStatesState.CA,
  '958': UnitedStatesState.CA,
  '959': UnitedStatesState.CA,
  '960': UnitedStatesState.CA,
  '961': UnitedStatesState.CA,
  '962': UnitedStatesState.AP,
  '963': UnitedStatesState.AP,
  '964': UnitedStatesState.AP,
  '965': UnitedStatesState.AP,
  '966': UnitedStatesState.AP,
  '967': UnitedStatesState.HI,
  '968': UnitedStatesState.HI,
  '969': UnitedStatesState.GU,
  '970': UnitedStatesState.OR,
  '971': UnitedStatesState.OR,
  '972': UnitedStatesState.OR,
  '973': UnitedStatesState.OR,
  '974': UnitedStatesState.OR,
  '975': UnitedStatesState.OR,
  '976': UnitedStatesState.OR,
  '977': UnitedStatesState.OR,
  '978': UnitedStatesState.OR,
  '979': UnitedStatesState.OR,
  '980': UnitedStatesState.WA,
  '981': UnitedStatesState.WA,
  '982': UnitedStatesState.WA,
  '983': UnitedStatesState.WA,
  '984': UnitedStatesState.WA,
  '985': UnitedStatesState.WA,
  '986': UnitedStatesState.WA,
  '987': UnitedStatesState.none,
  '988': UnitedStatesState.WA,
  '989': UnitedStatesState.WA,
  '990': UnitedStatesState.WA,
  '991': UnitedStatesState.WA,
  '992': UnitedStatesState.WA,
  '993': UnitedStatesState.WA,
  '994': UnitedStatesState.WA,
  '995': UnitedStatesState.AK,
  '996': UnitedStatesState.AK,
  '997': UnitedStatesState.AK,
  '998': UnitedStatesState.AK,
  '999': UnitedStatesState.AK,
};

export function zipCodeToState(zipCode: string): UnitedStatesState {
  if (!isString(zipCode)) {
    return UnitedStatesState.none;
  }

  const prefix = zipCode.substring(0, 3) as keyof typeof zipCodePrefixMap;

  return zipCodePrefixMap[prefix] ?? UnitedStatesState.none;
}
